import { Middleware } from 'redux'
import { isActionOf } from 'typesafe-actions'
import { ApiRequest } from '../../apiRequest'
import {
    loadConfigurationByVin,
    loadConfigurationByVinAsync,
    resetVinDataStatusState, setVinDataStatusState,
} from '../../actions/app/vin.actions'
import { loadConfigurationByVinApiUrl } from '../../../constants/apiUrls'
import isVwnRecommendationsEnabledSelector
    from '../../selectors/feature-scope/isVwnRecommendationsEnabledSelector'
import { fetchConfiguration } from '../../actions/app/configuration.actions'
import { fetchCart } from '../../actions/app/cart.actions'
import { fetchEquipmentGroups } from '../../actions/app/equipmentGroups.actions'
import { fetchVisualization } from '../../actions/app/visualization.actions'
import { setShouldNavigateToTarget } from '../../actions/app/navigation.actions'
import { fetchVwnModelsWithRecommendations } from '../../actions/app/vwnRecommendation.actions'
import { stringify } from 'query-string'
import VinRequestData from '../../../entities/VinRequestData'

const VinMiddleware =
    (apiRequest: ApiRequest): Middleware =>
        (store) =>
            (next) =>
                (action) => {
                    next(action)
                    const { dispatch, getState } = store

                    if (isActionOf(loadConfigurationByVin, action)) {
                        const vinRequestData: VinRequestData = action.payload

                        const requestParams = stringify(vinRequestData, {
                            skipNull: true,
                            sort: false,
                            encode: false,
                        })

                        apiRequest(
                            {
                                options: {
                                    url: loadConfigurationByVinApiUrl(requestParams),
                                    method: 'POST',
                                },
                                asyncActions: loadConfigurationByVinAsync,
                                causedBy: action,
                            },
                            dispatch,
                        )
                    }

                    if (isActionOf(loadConfigurationByVinAsync.success, action)) {
                        const { status, models, alternatives } = action.payload
                        const state = getState()
                        const isVwnRecommendationsEnabled = isVwnRecommendationsEnabledSelector(state)

                        if (status === 'OK') {
                            dispatch(fetchConfiguration())
                            dispatch(fetchCart())
                            dispatch(fetchEquipmentGroups())
                            dispatch(fetchVisualization())
                            dispatch(resetVinDataStatusState())
                            dispatch(setShouldNavigateToTarget(true))

                            if (isVwnRecommendationsEnabled) {
                                dispatch(fetchVwnModelsWithRecommendations())
                            }
                        }

                        if (status === "ERROR" && (models || alternatives)) {
                            const vinData = {
                                ...action.payload,
                                vinCode: (action as any).meta?.causedBy.payload?.vin,
                            }
                            dispatch(setVinDataStatusState(vinData))
                        }
                    }

                    if (isActionOf(loadConfigurationByVinAsync.failure, action)) {
                        dispatch(resetVinDataStatusState())
                    }
                }

export default VinMiddleware
